import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "new-order-list-content"
};
import FilterHeader from './components/FilterHeader.vue';
import OrderTableBlock from '@/views/orderManage/orderList/components/OrderTableBlock.vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'orderList'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const tableRef = ref(null);
    const loading = ref(false);
    const tableType = ref('1');
    const filterHeaderRef = ref(null);
    const filterSubmit = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    const closeMore = bool => {
      var _tableRef$value2;
      (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.closeMore(bool);
    };
    const updateLoading = e => {
      loading.value = e;
    };
    const updateApp = e => {
      filterHeaderRef.value.filterForm.dbtId = e;
      //   filterHeaderRef.value?.changeApp(e)
    };
    const initDataSource = () => {
      var _tableRef$value3;
      (_tableRef$value3 = tableRef.value) === null || _tableRef$value3 === void 0 || _tableRef$value3.initDataSource();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(FilterHeader, {
        ref_key: "filterHeaderRef",
        ref: filterHeaderRef,
        onFilterSubmit: filterSubmit,
        onCloseMore: closeMore,
        loading: loading.value,
        onInitDataSource: initDataSource
      }, null, 8, ["loading"]), _createVNode(OrderTableBlock, {
        ref_key: "tableRef",
        ref: tableRef,
        onUpdateLoading: updateLoading,
        "table-type": tableType.value,
        onUpdateApp: updateApp
      }, null, 8, ["table-type"])]);
    };
  }
});